/**
 * BundleSuite BYOB — sale display helpers.
 *
 * Flash (october-flash-sale):
 *  - hide repeated % on box size pills
 *  - inject compare-at (strikethrough) into In Page product cards
 * Legacy full-page BYOB: display 30% / 40% regardless of app tier numbers
 * (12.5 or 15 → 30, 20 or 25 → 40).
 *
 * REVERT AFTER SALE: set ENABLED false, or remove this file + theme.liquid script tag.
 */
(function () {
  const ENABLED = true;
  const FLASH_PATH = '/products/october-flash-sale';
  const CONTAINER = '.bundlesuite-container';
  const TITLE = '.discount-info-item-title';
  const CARD = '.inline-byob-product-card';
  const PRICE = '.product-price';
  const MARK = 'data-kick-compare-done';

  const productCache = Object.create(null);
  const pendingHandles = Object.create(null);

  let observer = null;
  let eventsBound = false;
  let applying = false;
  let scheduled = false;

  function isFlashPage() {
    return window.location.pathname.indexOf(FLASH_PATH) !== -1;
  }

  function rewriteLegacy(text) {
    if (!text) return text;
    return text
      .replace(/12\.5\s*%/g, '30%')
      .replace(/(^|[^\d.])15\s*%/g, '$130%')
      .replace(/(^|[^\d.])25\s*%/g, '$140%')
      .replace(/(^|[^\d.])20\s*%/g, '$140%');
  }

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    const amount = Number(cents) / 100;
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(cents, '{{amount}}').replace(/\.00$/, '');
      } catch (e) {
        /* fall through */
      }
    }
    const whole = Math.round(amount);
    return '₪' + whole.toLocaleString('en-IL');
  }

  function handleFromCard(card) {
    const link = card.querySelector('a.product-link[href*="/products/"], a[href*="/products/"]');
    if (!link) return null;
    try {
      const path = new URL(link.href, window.location.origin).pathname;
      const match = path.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function resolveCompare(product, card) {
    if (!product) return null;
    const variantId = card.getAttribute('data-selected-variant-id');
    let variant = null;
    if (variantId && Array.isArray(product.variants)) {
      variant = product.variants.find((v) => String(v.id) === String(variantId)) || null;
    }
    if (!variant && Array.isArray(product.variants) && product.variants.length) {
      variant = product.variants[0];
    }

    /* Prefer selected/first variant compare-at only — product-level can be a pack price. */
    const price = variant && variant.price != null ? variant.price : product.price;
    const compare = variant && variant.compare_at_price != null ? variant.compare_at_price : null;

    if (price == null || compare == null) return null;
    if (Number(compare) <= Number(price)) return null;
    return { price: Number(price), compare: Number(compare) };
  }

  function paintCompare(card, data) {
    const priceEl = card.querySelector(PRICE);
    if (!priceEl || !data) return;
    if (priceEl.getAttribute(MARK) === '1') return;

    priceEl.setAttribute(MARK, '1');
    priceEl.innerHTML =
      '<span class="kick-byob-compare-price">' +
      formatMoney(data.compare) +
      '</span><span class="kick-byob-sale-price">' +
      formatMoney(data.price) +
      '</span>';
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    if (pendingHandles[handle]) return pendingHandles[handle];

    pendingHandles[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((json) => {
        productCache[handle] = json;
        delete pendingHandles[handle];
        return json;
      })
      .catch(() => {
        delete pendingHandles[handle];
        return null;
      });

    return pendingHandles[handle];
  }

  function injectComparePrices() {
    const cards = document.querySelectorAll(CARD);
    cards.forEach((card) => {
      const priceEl = card.querySelector(PRICE);
      if (!priceEl || priceEl.getAttribute(MARK) === '1') return;

      const handle = handleFromCard(card);
      if (!handle) return;

      fetchProduct(handle).then((product) => {
        const data = resolveCompare(product, card);
        if (data) paintCompare(card, data);
        else priceEl.setAttribute(MARK, '0');
      });
    });
  }

  function applyFlash() {
    document.querySelectorAll('.inline-byob-discount-wrapper .box-price').forEach((el) => {
      el.style.display = 'none';
    });
    injectComparePrices();
  }

  function applyLegacy() {
    const root = document.querySelector(CONTAINER);
    if (!root) return;
    root.querySelectorAll(TITLE).forEach((el) => {
      const target = el.querySelector('h3') || el;
      const next = rewriteLegacy(target.textContent);
      if (next && next !== target.textContent) target.textContent = next;
    });
  }

  function apply() {
    if (!ENABLED || applying) return;
    applying = true;
    if (observer) observer.disconnect();

    if (isFlashPage()) {
      applyFlash();
    } else {
      applyLegacy();
    }

    applying = false;
    bindObserver();
  }

  function scheduleApply() {
    if (applying || scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      apply();
    });
  }

  function bindObserver() {
    if (typeof MutationObserver === 'undefined') return;
    const root = isFlashPage()
      ? document.querySelector('.inline-byob-container') ||
        document.querySelector('.inline-byob-discount-wrapper')
      : document.querySelector(`${CONTAINER} .template-top-data-discount-info`);
    if (!root) return;
    if (!observer) observer = new MutationObserver(scheduleApply);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  }

  function bindEvents() {
    if (eventsBound) return;
    eventsBound = true;
    document.addEventListener('bundleInitialized', scheduleApply);
  }

  function init() {
    if (!ENABLED) return;
    if (isFlashPage()) {
      if (!document.querySelector('.inline-byob-discount-wrapper') && !document.querySelector(CARD)) {
        setTimeout(init, 400);
        return;
      }
    } else if (!document.querySelector(CONTAINER)) {
      return;
    }
    bindEvents();
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('bundleInitialized', init);
})();
